export const EXPIRING_STATUS = [
  { id: 1, label: 'Upsell' },
  { id: 2, label: 'Cross Sell' },
  { id: 3, label: 'Not Retained' },
  { id: 4, label: 'Lost Opportunity' },
];
